export interface Album {
  mbid: string;
  '#text': string;
  name: string;
  url: string;
  artist: {
    url: string;
    name: string;
  };
  playcount: string; // convert to number
  image: {
    '#text': string;
    size: 'small' | 'medium' | 'large' | 'extralarge';
  }[];
}

export interface TopAlbumResponse {
  topAlbums: Album[];
}

export const getAlbumImage = (image: Album['image']): string | undefined =>
  image.find((item) => item.size === 'extralarge')?.['#text'] ||
  image[0]['#text'];
